import { render, staticRenderFns } from "./nologoff.vue?vue&type=template&id=7f8f09ef&scoped=true"
import script from "./nologoff.vue?vue&type=script&lang=js"
export * from "./nologoff.vue?vue&type=script&lang=js"
import style0 from "./nologoff.vue?vue&type=style&index=0&id=7f8f09ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8f09ef",
  null
  
)

export default component.exports